export type IpProtocol = {
  name: string;
  num: number;
};

export function ipProtocols(): IpProtocol[] {
  return [
    // 2018-05-11, https://www.iana.org/assignments/protocol-numbers/protocol-numbers.xml
    { name: 'hopopt', num: 0 },
    { name: 'hbh', num: 0 }, // hop-by-hop added manually - used by Cisco IOS object-groups
    { name: 'icmp', num: 1 },
    { name: 'igmp', num: 2 },
    { name: 'ggp', num: 3 },
    { name: 'ipinip', num: 4 }, // added manually
    { name: 'ipv4', num: 4 }, // 'ipv4' is in the IANA list
    { name: 'st', num: 5 },
    { name: 'tcp', num: 6 },
    { name: 'cbt', num: 7 },
    { name: 'egp', num: 8 },
    { name: 'igrp', num: 9 }, // added manually
    { name: 'igp', num: 9 }, // 'igp' is in the IANA list
    { name: 'bbn-rcc-mon', num: 10 },
    { name: 'nvp-ii', num: 11 },
    { name: 'pup', num: 12 },
    { name: 'argus', num: 13 },
    { name: 'emcon', num: 14 },
    { name: 'xnet', num: 15 },
    { name: 'chaos', num: 16 },
    { name: 'udp', num: 17 },
    { name: 'mux', num: 18 },
    { name: 'dcn-meas', num: 19 },
    { name: 'hmp', num: 20 },
    { name: 'prm', num: 21 },
    { name: 'xns-idp', num: 22 },
    { name: 'trunk-1', num: 23 },
    { name: 'trunk-2', num: 24 },
    { name: 'leaf-1', num: 25 },
    { name: 'leaf-2', num: 26 },
    { name: 'rdp', num: 27 },
    { name: 'irtp', num: 28 },
    { name: 'iso-tp4', num: 29 },
    { name: 'netblt', num: 30 },
    { name: 'mfe-nsp', num: 31 },
    { name: 'merit-inp', num: 32 },
    { name: 'dccp', num: 33 },
    { name: '3pc', num: 34 },
    { name: 'idpr', num: 35 },
    { name: 'xtp', num: 36 },
    { name: 'ddp', num: 37 },
    { name: 'idpr-cmtp', num: 38 },
    { name: 'tp++', num: 39 },
    { name: 'il', num: 40 },
    { name: 'ipv6', num: 41 },
    { name: 'sdrp', num: 42 },
    { name: 'ipv6-route', num: 43 },
    { name: 'ipv6-frag', num: 44 },
    { name: 'idrp', num: 45 },
    { name: 'rsvp', num: 46 },
    { name: 'pptp', num: 47 }, // added manually (Cisco ASA 5510 ver 9.1(7)16 uses two names for num 47 - gre and pptp)
    { name: 'gre', num: 47 },
    { name: 'dsr', num: 48 },
    { name: 'bna', num: 49 },
    { name: 'ipsec', num: 50 }, // added manually (Cisco ASA 5510 ver 9.1(7)16 uses two names for num 50 - esp and ipsec)
    { name: 'esp', num: 50 },
    { name: 'ahp', num: 51 }, // added manually
    { name: 'ah', num: 51 }, // 'ah' is in the IANA list
    { name: 'i-nlsp', num: 52 },
    { name: 'swipe', num: 53 },
    { name: 'narp', num: 54 },
    { name: 'mobile', num: 55 },
    { name: 'tlsp', num: 56 },
    { name: 'skip', num: 57 },
    { name: 'icmp6', num: 58 }, // added manually
    { name: 'icmpv6', num: 58 }, // added manually
    { name: 'ipv6-icmp', num: 58 }, // 'ipv6-icmp' is in the IANA list
    { name: 'ipv6-nonxt', num: 59 },
    { name: 'ipv6-opts', num: 60 },
    { name: '61', num: 61 },
    { name: 'cftp', num: 62 },
    { name: '63', num: 63 },
    { name: 'sat-expak', num: 64 },
    { name: 'kryptolan', num: 65 },
    { name: 'rvd', num: 66 },
    { name: 'ippc', num: 67 },
    { name: '68', num: 68 },
    { name: 'sat-mon', num: 69 },
    { name: 'visa', num: 70 },
    { name: 'ipcv', num: 71 },
    { name: 'cpnx', num: 72 },
    { name: 'cphb', num: 73 },
    { name: 'wsn', num: 74 },
    { name: 'pvp', num: 75 },
    { name: 'br-sat-mon', num: 76 },
    { name: 'sun-nd', num: 77 },
    { name: 'wb-mon', num: 78 },
    { name: 'wb-expak', num: 79 },
    { name: 'iso-ip', num: 80 },
    { name: 'vmtp', num: 81 },
    { name: 'secure-vmtp', num: 82 },
    { name: 'vines', num: 83 },
    { name: 'ttp', num: 84 },
    { name: 'iptm', num: 84 },
    { name: 'nsfnet-igp', num: 85 },
    { name: 'dgp', num: 86 },
    { name: 'tcf', num: 87 },
    { name: 'eigrp', num: 88 },
    { name: 'ospf', num: 89 }, // added manually
    { name: 'ospfigp', num: 89 }, // 'ospfigp' is in the IANA list
    { name: 'sprite-rpc', num: 90 },
    { name: 'larp', num: 91 },
    { name: 'mtp', num: 92 },
    { name: 'ax.25', num: 93 },
    { name: 'nos', num: 94 }, // added manually
    { name: 'ipip', num: 94 }, // 'ipip' is in the IANA list
    { name: 'micp', num: 95 },
    { name: 'scc-sp', num: 96 },
    { name: 'etherip', num: 97 },
    { name: 'encap', num: 98 },
    { name: '99', num: 99 },
    { name: 'gmtp', num: 100 },
    { name: 'ifmp', num: 101 },
    { name: 'pnni', num: 102 },
    { name: 'pim', num: 103 },
    { name: 'aris', num: 104 },
    { name: 'scps', num: 105 },
    { name: 'qnx', num: 106 },
    { name: 'a/n', num: 107 },
    { name: 'pcp', num: 108 }, // 'pcp' as 'Payload Compression Protocol' added manually (used by e.g. Cisco service object-group)
    { name: 'ipcomp', num: 108 }, // 'ipcomp' is in the IANA list
    { name: 'snp', num: 109 },
    { name: 'compaq-peer', num: 110 },
    { name: 'ipx-in-ip', num: 111 },
    { name: 'vrrp', num: 112 },
    { name: 'pgm', num: 113 },
    { name: '114', num: 114 },
    { name: 'l2tp', num: 115 },
    { name: 'ddx', num: 116 },
    { name: 'iatp', num: 117 },
    { name: 'stp', num: 118 },
    { name: 'srp', num: 119 },
    { name: 'uti', num: 120 },
    { name: 'smp', num: 121 },
    { name: 'sm', num: 122 },
    { name: 'ptp', num: 123 },
    { name: 'isisoveripv4', num: 124 },
    { name: 'fire', num: 125 },
    { name: 'crtp', num: 126 },
    { name: 'crudp', num: 127 },
    { name: 'sscopmce', num: 128 },
    { name: 'iplt', num: 129 },
    { name: 'sps', num: 130 },
    { name: 'pipe', num: 131 },
    { name: 'sctp', num: 132 },
    { name: 'fc', num: 133 },
    { name: 'rsvp-e2e-ignore', num: 134 },
    { name: 'mobilityheader', num: 135 },
    { name: 'udplite', num: 136 },
    { name: 'mpls-in-ip', num: 137 },
    { name: 'manet', num: 138 },
    { name: 'hip', num: 139 },
    { name: 'shim6', num: 140 },
    { name: 'wesp', num: 141 },
    { name: 'rohc', num: 142 },
    { name: '143', num: 143 },
    { name: '144', num: 144 },
    { name: '145', num: 145 },
    { name: '146', num: 146 },
    { name: '147', num: 147 },
    { name: '148', num: 148 },
    { name: '149', num: 149 },
    { name: '150', num: 150 },
    { name: '151', num: 151 },
    { name: '152', num: 152 },
    { name: '153', num: 153 },
    { name: '154', num: 154 },
    { name: '155', num: 155 },
    { name: '156', num: 156 },
    { name: '157', num: 157 },
    { name: '158', num: 158 },
    { name: '159', num: 159 },
    { name: '160', num: 160 },
    { name: '161', num: 161 },
    { name: '162', num: 162 },
    { name: '163', num: 163 },
    { name: '164', num: 164 },
    { name: '165', num: 165 },
    { name: '166', num: 166 },
    { name: '167', num: 167 },
    { name: '168', num: 168 },
    { name: '169', num: 169 },
    { name: '170', num: 170 },
    { name: '171', num: 171 },
    { name: '172', num: 172 },
    { name: '173', num: 173 },
    { name: '174', num: 174 },
    { name: '175', num: 175 },
    { name: '176', num: 176 },
    { name: '177', num: 177 },
    { name: '178', num: 178 },
    { name: '179', num: 179 },
    { name: '180', num: 180 },
    { name: '181', num: 181 },
    { name: '182', num: 182 },
    { name: '183', num: 183 },
    { name: '184', num: 184 },
    { name: '185', num: 185 },
    { name: '186', num: 186 },
    { name: '187', num: 187 },
    { name: '188', num: 188 },
    { name: '189', num: 189 },
    { name: '190', num: 190 },
    { name: '191', num: 191 },
    { name: '192', num: 192 },
    { name: '193', num: 193 },
    { name: '194', num: 194 },
    { name: '195', num: 195 },
    { name: '196', num: 196 },
    { name: '197', num: 197 },
    { name: '198', num: 198 },
    { name: '199', num: 199 },
    { name: '200', num: 200 },
    { name: '201', num: 201 },
    { name: '202', num: 202 },
    { name: '203', num: 203 },
    { name: '204', num: 204 },
    { name: '205', num: 205 },
    { name: '206', num: 206 },
    { name: '207', num: 207 },
    { name: '208', num: 208 },
    { name: '209', num: 209 },
    { name: '210', num: 210 },
    { name: '211', num: 211 },
    { name: '212', num: 212 },
    { name: '213', num: 213 },
    { name: '214', num: 214 },
    { name: '215', num: 215 },
    { name: '216', num: 216 },
    { name: '217', num: 217 },
    { name: '218', num: 218 },
    { name: '219', num: 219 },
    { name: '220', num: 220 },
    { name: '221', num: 221 },
    { name: '222', num: 222 },
    { name: '223', num: 223 },
    { name: '224', num: 224 },
    { name: '225', num: 225 },
    { name: '226', num: 226 },
    { name: '227', num: 227 },
    { name: '228', num: 228 },
    { name: '229', num: 229 },
    { name: '230', num: 230 },
    { name: '231', num: 231 },
    { name: '232', num: 232 },
    { name: '233', num: 233 },
    { name: '234', num: 234 },
    { name: '235', num: 235 },
    { name: '236', num: 236 },
    { name: '237', num: 237 },
    { name: '238', num: 238 },
    { name: '239', num: 239 },
    { name: '240', num: 240 },
    { name: '241', num: 241 },
    { name: '242', num: 242 },
    { name: '243', num: 243 },
    { name: '244', num: 244 },
    { name: '245', num: 245 },
    { name: '246', num: 246 },
    { name: '247', num: 247 },
    { name: '248', num: 248 },
    { name: '249', num: 249 },
    { name: '250', num: 250 },
    { name: '251', num: 251 },
    { name: '252', num: 252 },
    { name: '253', num: 253 },
    { name: '254', num: 254 },
    { name: 'reserved', num: 255 },
  ];
}
